import { render, staticRenderFns } from "./wifiMall.vue?vue&type=template&id=1f8b7e30&scoped=true"
import script from "./wifiMall.vue?vue&type=script&lang=js"
export * from "./wifiMall.vue?vue&type=script&lang=js"
import style0 from "./wifiMall.vue?vue&type=style&index=0&id=1f8b7e30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b7e30",
  null
  
)

export default component.exports